import { useSuspenseQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { TGetEmpreendimentosDisponiveisResponse } from '@/features/empreendimentos/interfaces/empreendimento.types'
import { GetEmpreendimentosDisponiveisService } from '@/features/empreendimentos/services/get-empreendimentos-disponiveis.service'
import { empreendimentosKeys } from '@/features/empreendimentos/utils'

export const useEmpreendimentosDisponiveisSuspense = () => {
  return useSuspenseQuery<TGetEmpreendimentosDisponiveisResponse, AxiosError>({
    queryKey: empreendimentosKeys.disponiveis(),
    queryFn: () => new GetEmpreendimentosDisponiveisService().execute().then((response) => response.data),
  })
}
